"use strict";
var SampleModuleCtrl = (function () {
    function SampleModuleCtrl($scope, $element, AngularPopgunSrvc) {
        AngularPopgunSrvc.init($scope, $element[0]);
    }
    return SampleModuleCtrl;
}());
exports.SampleModuleCtrl = SampleModuleCtrl;
//# sourceMappingURL=SampleModuleCtrl.js.map